const SEPARATOR = '::'

/**
 * Normalizes a string by trimming and replacing spaces with underscores.
 */
const normalize = value => String(value).trim()

/**
 * Safely encodes a string to avoid separator conflicts.
 */
const encodePart = part => encodeURIComponent(normalize(part))

/**
 * Decodes a previously encoded string.
 */
const decodePart = part => decodeURIComponent(part)

/**
 * Generates a unique ID by combining `group`, `name`, and `id`.
 * @param {Object} params
 * @param {string} params.id
 * @param {string} params.group
 * @param {string} params.name
 * @returns {string}
 */
export const generateUniqueId = ({group, id, name}) => {
  const parts = [group, name, id].map(encodePart)
  return parts.join(SEPARATOR)
}

/**
 * Parses a previously generated unique ID back into its original parts.
 * @param {Object} params
 * @param {string} params.uniqueId
 * @returns {{ group: string, id: string, name: string }}
 */
export const parseUniqueId = ({uniqueId}) => {
  const parts = uniqueId.split(SEPARATOR)
  const [group, name, id] = parts.map(decodePart)
  return {group, id, name}
}
